import React, { useEffect, useState } from "react";
import Select from "react-select";
import Navbar from "../../components/Navbar";
import Feature from "../../components/Feature";
import Footer from "../../components/Footer";
import JobJob from "../../components/jobjob";
import {
  BiBriefcaseAlt2,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  PiMapPin,
} from "../../assets/icons/vander";
import ExploreJob from "../../components/Explore-job";
import { api } from "../..";
import { Loader } from "../../components/Loader";
import PremiumBanner from "../../components/Buy-premium";
import { jobDataStore } from "../../zustStore";

export default function JobGridsThree() {
  const [jobData, setJobData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1); // Assuming the API will return total pages
  const [showLoader, setShowloader] = useState(true);
  const { jobListingData, setJobListings, count, setPageCount } =
    jobDataStore();

  const handleClick = async (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return; // Prevent out-of-bounds pagination

    try {
      const response = await fetch(`${api}/get-jobs?page=${pageNumber}`);
      if (response.ok) {
        const data = await response.json();
        console.log("DATA FROM JOBS>>>>>", data);
        setJobData(data.all_jobs);
        setTotalPages(data.totalPages); // API returns totalPages
        setPage(pageNumber);
      } else {
        throw new Error("Failed to fetch data");
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    const fetchCompaniesData = async () => {
      try {
        setShowloader(true);
        // try fetching data from store
        let response = {};
        // console.log("---- ", page, " ", jobListingData);
        if (page in jobListingData) {
          console.log(page);
          response.all_jobs = jobListingData[page];
          response.ok = true;
          response.totalPages = count;
          response.store = true;
        } else response = await fetch(`${api}/get-jobs?page=${page}`);
        if (response.ok) {
          // console.log(response);
          let data = null;
          if (response?.store) data = response;
          else data = await response.json();
          // console.log("DATA FROM JOBS>>>>>", data);
          setJobData(data.all_jobs);
          setTotalPages(data.totalPages); // API returns totalPages
          // add data to store
          if (!response?.store) {
            setJobListings(page, data.all_jobs);
            setPageCount(data.totalPages);
          }
          setShowloader(false);
        } else {
          throw new Error("Failed to fetch data");
        }
      } catch (error) {
        console.error(error.message);
      }
    };

    fetchCompaniesData();
  }, [page]); // The page state is a dependency here

  return (
    <>
      <Navbar navClass="justify-end nav-light" />

      {showLoader ? (
        <Loader />
      ) : (
        <>
          <section className="relative table w-full py-36 bg-[url('../../assets/images/hero/bg.jpg')] bg-top bg-no-repeat bg-cover">
            <div className="absolute inset-0 bg-emerald-900/90"></div>
            <div className="container">
              <div className="grid grid-cols-1 text-center mt-10">
                <h3 className="md:text-3xl text-2xl md:leading-snug tracking-wide leading-snug font-medium text-white">
                  Job Vacancies
                </h3>
              </div>
            </div>
          </section>
          <div className="relative">
            <div className="shape absolute start-0 end-0 sm:-bottom-px -bottom-[2px] overflow-hidden z-1 text-white dark:text-slate-900">
              <svg
                className="w-full h-auto"
                viewBox="0 0 2880 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
                  fill="currentColor"
                ></path>
              </svg>
            </div>
          </div>
          <section className="relative -mt-[42px] md:pb-24 pb-16">
            <div className="container z-1">
              <div className="d-flex" id="reserve-form">
                <div className="md:w-5/6 mx-auto">
                  <div className="lg:col-span-10">
                    {/* Search Form is commented out in the original code, you can enable it here if needed */}
                  </div>
                </div>
              </div>
            </div>

            <JobJob Joblist={jobData} />
            <div className="grid md:grid-cols-6 grid-cols-1 mt-8">
              <div className="md:col-span-12 text-center">
                <nav aria-label="Page navigation example">
                  <ul className="inline-flex items-center -space-x-px">
                    <li>
                      <p
                        onClick={() => handleClick(page - 1)}
                        className={`size-[40px] inline-flex justify-center items-center text-slate-400 bg-white dark:bg-slate-900 rounded-s-3xl hover:text-white border border-gray-100 dark:border-gray-800 hover:border-emerald-600 dark:hover:border-emerald-600 hover:bg-indigo-600 dark:hover:bg-indigo-600 ${
                          page === 1 ? "cursor-not-allowed" : ""
                        }`}
                      >
                        <MdKeyboardArrowLeft className="text-[20px] rtl:rotate-180 rtl:-mt-1" />
                      </p>
                    </li>
                    {[...Array(totalPages)].map((_, index) => (
                      <li key={index}>
                        <p
                          onClick={() => handleClick(index + 1)}
                          className={`size-[30px] inline-flex bg-red-500 justify-center items-center text-slate-400 hover:text-white dark:bg-slate-900 border border-gray-100 dark:border-gray-800 hover:border-emerald-600 dark:hover:border-emerald-600 hover:bg-indigo-600 dark:hover:bg-indigo-600 ${
                            page === index + 1
                              ? " bg-indigo-600 text-indigo-600"
                              : " bg-white"
                          }`}
                        >
                          {index + 1}
                        </p>
                      </li>
                    ))}
                    <li>
                      <p
                        onClick={() => handleClick(page + 1)}
                        className={`size-[40px] inline-flex justify-center items-center text-slate-400 bg-white dark:bg-slate-900 rounded-e-3xl hover:text-white border border-gray-100 dark:border-gray-800 hover:border-emerald-600 dark:hover:border-emerald-600 hover:bg-indigo-600 dark:hover:bg-indigo-600 ${
                          page === totalPages ? "cursor-not-allowed" : ""
                        }`}
                      >
                        <MdKeyboardArrowRight className="text-[20px] rtl:rotate-180 rtl:-mt-1" />
                      </p>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <Feature />
            <ExploreJob />
          </section>
        </>
      )}

      <Footer />
      <PremiumBanner />
    </>
  );
}
